import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { CaseDetailsApplicationContainer } from '../components/case-details-application.container.tsx';
import { Helmet } from 'react-helmet';

export const ApplicationSendReport: React.FC = () => {
  const params = useParams();
  return (
    <div style={{ marginTop: '25px' }}>
      <Helmet>
        <title>Case - Application</title>
      </Helmet>
      <SubPageLayout title="Send Report Request">
        <CaseDetailsApplicationContainer caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </div>
  );
};
